import apiResponse from "@/modules/apiResponse";
import tokenCookie from "@/modules/tokenCookie";
import Apis from "@/urls/apis";
import axios from "axios";
const { hasValidToken, getToken } = tokenCookie();
const { errorResponse } = apiResponse();

const state = {
  ticketDetails: {},
};
const getters = {
  getTicketDetailsVerified: (state) => state.ticketDetails,
};
const actions = {
  async verifyCountermanTicket({ commit }, payload) {
    if (await hasValidToken()) {
      const header = {
        Authorization: "Bearer " + getToken(),
      };

      return new Promise((resolve, reject) => {
        axios
          .post(Apis.VERIFY_TICKET_COUNTERMAN, payload, { headers: header })
          .then(({ data, status }) => {
            if (status === 200) {
              commit("setTicketDetails", data.ticket);
              resolve(data.ticket);
            }
          })
          .catch((error) => {
            reject(errorResponse(error));
          });
      });
    }
  },
};
const mutations = {
  setTicketDetails: (state, ticketDetails) =>
    (state.ticketDetails = ticketDetails),
};

export default {
  state,
  getters,
  actions,
  mutations,
};
